// 首页模拟数据
export const recommendList = [
	{
		title: '优惠券',
		msg: '现金券、折扣券、营销必备',
		icon: 'el-icon-food',
		bg: '#48D18D',
		iconColor: '#64d89d',
	},
	{
		title: '多人拼团',
		msg: '社交电商、开辟流量',
		icon: 'el-icon-shopping-bag-1',
		bg: '#F95959',
		iconColor: '#F86C6B',
	},
	{
		title: '分销中心',
		msg: '轻松招募分销员，成功推广奖励',
		icon: 'el-icon-school',
		bg: '#8595F4',
		iconColor: '#92A1F4',
	},
	{
		title: '秒杀',
		msg: '超低价抢购引导更多销量',
		icon: 'el-icon-alarm-clock',
		bg: '#FEBB50',
		iconColor: '#FDC566',
	},
];

export const chartsRightList = [
	{
		title: '距离60分钟订单数量',
		num: 188,
		icon: 'el-icon-document',
		iconBg: '#C3E9FE',
		color: '#1890FF',
	},
	{
		title: '距离30分钟订单数量',
		num: 15,
		icon: 'el-icon-tickets',
		iconBg: '#F1EBC5',
		color: '#FDB850',
	},
	{
		title: '已超时数量',
		num: 6,
		icon: 'el-icon-document-delete',
		iconBg: '#F2D7C4',
		color: '#F8958C',
	},
];

export const newsInfoList = [
	{
		title: '[发布] 2021年02月28日发布基于 vue3.x + vite v1.0.0 版本',
		date: '02/28',
		link: 'https://gitee.com/lyt-top/vue-next-admin',
	},
	{
		title: '[发布] 2021年04月15日发布 vue2.x + webpack 重构版本',
		date: '04/15',
		link: 'https://gitee.com/lyt-top/vue-next-admin/tree/vue-prev-admin/',
	},
	{
		title: '[重构] 2021年04月10日 重构 vue2.x + webpack v1.0.0 版本',
		date: '04/10',
		link: 'https://gitee.com/lyt-top/vue-next-admin/tree/vue-prev-admin/',
	},
	{
		title: '[预览] 2020年12月08日，基于 vue3.x 版本后台模板的预览',
		date: '12/08',
		link: 'http://lyt-top.gitee.io/vue-next-admin-preview/#/login',
	},
	{
		title: '[预览] 2020年11月15日，基于 vue2.x 版本后台模板的预览',
		date: '11/15',
		link: 'https://lyt-top.gitee.io/vue-prev-admin-preview/#/login',
	},
];

export const dailyMessage = [
	'祝你开心每一天！',
	'忙碌了一周，停一停脚步！',
	'世间美好，与你环环相扣！',
	'永远相信美好的事情即将发生！',
	'每一天，遇见更好的自己！',
	'保持热爱，奔赴山海！',
	'生活明朗，万物可爱！',
	'愿每一天醒来都是美好的开始！',
	'没有希望的地方，就没有奋斗！',
	'我最珍贵的时光都行走在路上！',
	'成功，往往住在失败的隔壁！',
	'人只要不失去方向，就不会失去自己！',
	'每条堵住的路，都有一个出口！',
	'没有谁能击垮你，除非你自甘堕落！',
	'微笑着的人并非没有痛苦！',
	'生活变的再糟糕，也不妨碍我变得更好！',
	'你要悄悄努力，然后惊艳众人！',
];
